export default __webpack_public_path__ + "59ced933bc303cd968eb56105e21af12.svg";